import { INTEGRATOR_EVENT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap, Record } from 'immutable';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
export const IntegratorEventRecord = Record({
  fullyQualifiedName: '',
  objectTypeId: '',
  label: '',
  primaryObjectTypeId: undefined
});
export class IntegratorEventsAdapterConfig extends HttpAdapterConfig {
  getCacheKey() {
    return 'INTEGRATOR_EVENTS';
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === INTEGRATOR_EVENT;
  }
  fetchData(httpClient) {
    return httpClient('events/internal/v0/app/event-types');
  }
  formatData(events) {
    return events.reduce((acc, event) => {
      const {
        eventTypeId,
        fullyQualifiedName,
        labels,
        primaryObjectTypeId
      } = event;
      if (eventTypeId.metaType === 'INTEGRATION_EVENT') {
        const objectTypeId = `5-${eventTypeId.innerId}`;
        const label = labels.singular || fullyQualifiedName;
        return acc.set(objectTypeId, IntegratorEventRecord({
          objectTypeId,
          label,
          fullyQualifiedName,
          primaryObjectTypeId
        }));
      }
      return acc;
    }, ImmutableMap());
  }
}
export default Adapter.makeFromConfig(IntegratorEventsAdapterConfig);